export default "__VITE_ASSET__CQg1LMej__"